import React from 'react';
import './FeedbackRow.css';

const FeedbackRow = (props) => {
    return (
        <div className="fbr-row">
            <div className="fbr-info">
                <p className="fbr-name">{props.name}</p>
                <p className="fbr-event">{props.event}</p>
                <p className="fbr-text">{props.text}</p>
            </div>
           
        </div>
    );
};

export default FeedbackRow;